import { connect } from "react-redux";
import { getShortAddress } from "../../../utils";
import { Divider } from "../art/Motifs";
import { eventPainting } from "../art/paintings";
import Reveal from "../Reveal";
import Section from "./Section";

const mapsLink = (venue) => `https://www.google.com/maps?q=${encodeURIComponent(`${venue}`)}`;

/**
 * "When & Where": each ceremony with its painted illustration (haldi, mehendi, sangeet, wedding, ...).
 */
const Events = ({ events }) => {
  const list = events || [];
  const anyArt = list.some((event) => eventPainting(event.name));

  return (
    <Section id="story" className="rm-events" label="When and where" kicker="Our Wedding" title="When & Where">
      <div className="rm-events__list">
        {list.map((event, i) => {
          const art = eventPainting(event.name);
          return (
            <Reveal key={`${event.name}-${i}`} className="rm-event" delay={0.1 + (i % 3) * 0.12}>
              {anyArt && (
                <div className="rm-event__art" aria-hidden="true">
                  {art && <img className="rm-painting" src={art} alt="" draggable="false" />}
                </div>
              )}
              <h3 className="rm-event__name">{event.name}</h3>
              <Divider className="rm-event__rule" />
              <p className="rm-kicker rm-event__date">{event?.dateAndTime?.date}</p>
              <p className="rm-event__time">{event?.dateAndTime?.time} Onwards</p>
              {event.theme && (
                <p className="rm-event__dress">
                  {event.theme.includes("Dinner is also") ? "" : "Dress Code - "}
                  {event.theme}
                </p>
              )}
              <a className="rm-event__venue" href={mapsLink(event?.venue)} target="_blank" rel="noreferrer">
                {getShortAddress(event?.venue)}
              </a>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(Events);
